module.exports = __webpack_public_path__ + "media/bundles/TriipApp/assets/images/logo-footer-4e60f0af54fd95e37bc4a7560ff23b47.png";